import React from 'react';
import { Container, Table } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { BackButton, CopyLinkButton, Loading, LoadingError } from '@components/Base';
import HeaderSecondary from '@components/HeaderSecondary';

import { useHealthQuotesFetch } from './hook';
import { TableInsurer } from './table-insurer';
import { TableAnnualLimit } from './table-annual-limit';
import { TableGeographicCoverage } from './table-geographic-coverage';
import {
  TableInpatientBenefit,
  TableOutpatientBenefit,
  TableHealthCheckupBenefit,
  TableMaternityBenefit,
  TableVisionBenefit,
  TableDentalBenefit,
  TableCopayBenefit,
  TableOthersBenefit,
} from './table-benefit';

const HealthQuoteComparePage = () => {
  const healthQuotes = useHealthQuotesFetch();

  if (isUndefined(healthQuotes)) return <Loading />;
  if (isNull(healthQuotes)) return <LoadingError />;

  return (
    <>
      <HeaderSecondary />

      <Container className="mt-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <BackButton />
          <CopyLinkButton />
        </div>

        <Table>
          <tbody>
            <TableInsurer />
            <TableAnnualLimit />
            <TableInpatientBenefit />
            <TableOutpatientBenefit />
            <TableHealthCheckupBenefit />
            <TableMaternityBenefit />
            <TableVisionBenefit />
            <TableDentalBenefit />
            <TableCopayBenefit />
            <TableOthersBenefit />
            <TableGeographicCoverage />
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export { HealthQuoteComparePage };
